import { useMutation } from '@tanstack/react-query';
import { ProjectImagesAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const projectImagesAPI = new ProjectImagesAPI(axios);

export const useProjectImageDeleteMutation = () => {
    return useMutation({
        mutationFn: async ({
            storageId,
            projectImageId
        }: {
            storageId: string;
            projectImageId: string;
        }) => projectImagesAPI.deleteProjectImage(storageId, projectImageId)
    });
};
